import React, { PureComponent } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Text,
  XAxis,
  LabelList,
  Tooltip,
  Legend,
} from 'recharts';


const CustomizedAxisTick = ({ x, y, payload }) => <Text fontSize={10} fontStyle="italic" textTransform="capitalize" x={x} y={y} width={75} fill="#818181" textAnchor="middle" verticalAnchor="start">{payload.value}</Text>;

class DriverCharts extends PureComponent {
  render() {
    const { data } = this.props;
    return (
      <ResponsiveContainer
        className={this.props.className}
        width="100%"
        height={310}
      >
        <BarChart
          data={data}
        >
          <XAxis
            dataKey="name"
            padding={{ left: 0, right: 0 }}
            tickLine={false}
            axisLine={false}
            interval={0}
            tickSize={3}
            tick={<CustomizedAxisTick />}
            height={100}
          />
          <Tooltip />
          <Legend />
          <Bar dataKey="discharges" fill="#8884d8" radius={[3, 3, 0, 0]} barSize={64}>
            <LabelList dataKey="discharges" position="top" fill="#8884d8" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default DriverCharts;
